import { useLang } from "./lang";
import { services as servicesEs } from "../content/services";
import { problems as problemsEs } from "../content/problems";
import { guides as guidesEs, upcomingGuides as upcomingEs, guideCategories as catsEs } from "../content/guides";
import { needOptions, homeFaqs } from "../content/site";
import {
  servicesEn,
  problemsEn,
  guidesEn,
  upcomingGuidesEn,
  guideCategoriesEn,
  needLabelsEn,
  homeFaqsEn,
} from "../content/en";

// Combina el contenido español con las traducciones inglesas disponibles:
// cada override se empareja por slug y sus campos sustituyen al español.
const bySlug = (esArr, enArr) =>
  esArr.map((item) => {
    const o = enArr.find((e) => e.slug === item.slug);
    return o ? { ...item, ...o } : item;
  });

export const useServices = () => {
  const l = useLang();
  return l === "en" ? bySlug(servicesEs, servicesEn) : servicesEs;
};

export const useProblems = () => {
  const l = useLang();
  return l === "en" ? bySlug(problemsEs, problemsEn) : problemsEs;
};

export const useGuides = () => {
  const l = useLang();
  return l === "en" ? bySlug(guidesEs, guidesEn) : guidesEs;
};

export const useUpcomingGuides = () => {
  const l = useLang();
  if (l !== "en" || !upcomingGuidesEn.length) return upcomingEs;
  // Overrides por posición (las guías en preparación no tienen slug)
  return upcomingEs.map((u, i) => ({ ...u, ...(upcomingGuidesEn[i] || {}) }));
};

export const useGuideCategories = () => {
  const l = useLang();
  return l === "en" && guideCategoriesEn.length ? guideCategoriesEn : catsEs;
};

// Valores del desplegable "necesidad": siempre los españoles (dato para la
// titular); las etiquetas visibles pueden ir en inglés.
export const useNeedLabels = () => {
  const l = useLang();
  return l === "en" && needLabelsEn.length === needOptions.length ? needLabelsEn : needOptions;
};

export const useHomeFaqs = () => {
  const l = useLang();
  return l === "en" && homeFaqsEn.length ? homeFaqsEn : homeFaqs;
};
